import type { StateCreator } from "zustand";
import { tmp } from "../tmpIds";
import type { DraftStoreState, DraftCanvas } from "./types";

export const createCanvasSlice: StateCreator<
  DraftStoreState,
  [],
  [],
  Pick<DraftStoreState, "addEdge" | "removeEdge" | "setCanvas">
> = (set) => ({
  setCanvas: (canvas: DraftCanvas) => {
    set({ canvas, dirty: true });
  },

  addEdge: (sourceNodeTmpId, targetNodeTmpId) => {
    const tmpEdgeId = tmp.edge();
    set((state) => ({
      canvas: {
        ...state.canvas,
        edges: [
          ...state.canvas.edges,
          {
            tmpId: tmpEdgeId,
            sourceNodeTmpId,
            targetNodeTmpId,
            type: "PRODUCTION_FLOW",
            data: {},
          },
        ],
      },
      dirty: true,
    }));
    return tmpEdgeId;
  },

  removeEdge: (tmpEdgeId) => {
    set((state) => ({
      canvas: {
        ...state.canvas,
        edges: state.canvas.edges.filter((e) => e.tmpId !== tmpEdgeId),
      },
      dirty: true,
    }));
  },
});
